
let currentProduct;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});


const waitForElement = (selector, timeout = 10000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};


// START A/B SECTION

await waitForMazingFunction;
await waitForElement('button[name="add"]');

mazingSetAB({
    enabled: true,
    addToCartListeners: (callback) => {

        document.querySelector('button[name="add"]').addEventListener('click', () => {
            console.log('MAZING: addToCartClicked A/B');
            callback();
        });

        return true;
    }
});


// END A/B SECTION


const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');

    currentProduct = `${productParts[0]}`;
    console.log('Base SKU:', currentProduct.toLowerCase());

    //console.log('Final SKU:', currentProduct.toLowerCase());

    return currentProduct.toLowerCase();
};


const initializeMazing = async (placementSelector) => {
    await mazing({
        customerName: 'INFODIVINUSFURNITURECOM',
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    position: absolute;
                    bottom: 10px;
                    width: 100%;
                    justify-content: flex-end;
                    z-index: 10;
                }
                
                .mazing-threed-btn {
                    margin-left: 8px;
                    padding-right: 34px;
                    padding-left: 34px;
                }
                
                .mazing-ar-btn {
                    margin-right: 8px;
                }
                
                .mazing-threed-btn-text{
                    color: #3b4560;
                }
                
                .mazing-ar-btn-text{
                    color: #3b4560;
                }
                
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(27%) sepia(36%) saturate(480%) hue-rotate(185deg) brightness(85%) contrast(90%);
                } 
                
                .mazing-ar-btn-icon {
                    filter: brightness(0) saturate(100%) invert(27%) sepia(36%) saturate(480%) hue-rotate(185deg) brightness(85%) contrast(90%);
                }
            `,
            placementSelector,
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: false,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        en: "View in Room",
                        de: "Im Raum anzeigen",
                        fr: "Voir dans votre espace",
                        es: "Ver en tu espacio"
                    };
                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing v 1.1 initialized for:', placementSelector);
};

const cleanupMazing = () => {
    document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
    document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());
};

let currentMode = null;

const getViewportMode = () => {
    return window.innerWidth > 960 ? 'desktop' : 'mobile';
};

const startMazingForCurrentMode = async () => {
    const mode = getViewportMode();
    if (mode === currentMode) return;

    currentMode = mode;
    cleanupMazing();

    if (mode === 'desktop') {
        await initializeMazing('.product__media-container.above-mobile.lightbox-media-container .product__media-item .media');
    } else {
        await initializeMazing('.product__media-container.below-mobile.carousel');
    }

    console.log(`Mazing initialized in ${mode} mode`);
};


const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        await startMazingForCurrentMode();

        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(startMazingForCurrentMode, 100);
        });

        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

initializeScript();